export default {"src":"/_next/static/media/college5.bab87142.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};